import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { AgencyState } from '../types';
import AgencyForm from '../AgencyForm';

/**
 * AgenciesFormコンポーネント用のPropsです。
 * @interface AgenciesFormProps
 */
interface AgenciesFormProps {

  /**
   * 代理人（複数）
   * @type {Agency[]}
   * @memberof AgenciesFormProps
   */
  agencies: AgencyState[];

  /**
   * 代理人（複数）を設定する関数
   * @memberof AgenciesFormProps
   */
  onChange: (agencies: AgencyState[]) => void;

}

/**
 * 代理人（複数）フォームのコンポーネントです。
 * @param {string} props.agencies - 代理人（複数）
 * @param {function} props.onChange - 代理人（複数）が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - 代理人（複数）フォームのJSX要素
 */
const AgenciesForm: React.FC<AgenciesFormProps> = ({ agencies, onChange }) => {

  /**
   * 代理人フォームを追加する関数です。
   * @param {AgencyState} addedAgency - 代理人
   * @returns {void}
   */
  const addAgency = (addedAgency: AgencyState): void => {
    onChange([...agencies, addedAgency]);
  }

  /**
   * 代理人フォームを削除する関数です。
   * @param {number} removedAgencyIndex - 削除する代理人の索引
   * @returns {void}
   */
  const deleteAgency = (removedAgencyIndex: number): void => {
    if(removedAgencyIndex !== 0) {
      onChange(
        agencies.filter((_agency, i) => (i !== removedAgencyIndex))
      );
    }
  }

  /**
   * 代理人フォームを更新する関数です。
   * @param {number} updatedAgencyIndex - 更新する代理人の索引
   * @param {string} updatedAgency - 更新する代理人
   * @returns {void}
   */
  const updateAgency = (updatedAgencyIndex: number, updatedAgency: AgencyState): void => {
    onChange(
      agencies.map((agency, i) => (i === updatedAgencyIndex ? updatedAgency : agency))
    );
  }

  /** 
   * 代理人の初期値
   * @type {Agency}
   */
  const emptyeAgency: AgencyState = {
    isProcedureExecutor: false,
    identificationNumber: {
      value: '',
      errorMessage: ''
    },
    address: {
      value: '',
      errorMessage: ''
    },
    name: {
      value: '',
      errorMessage: ''
    },
    representative: {
      value: '',
      errorMessage: ''
    }
  };

  return (
    <>
      <Form.Label>選任した代理人（受任者）</Form.Label>
      <div className="text-end" style={{marginTop: '-2rem'}}>
        <div className="mx-1 d-inline">
          <Button
            variant="primary"
            className="rounded-circle py-1 px-2 text-white"
            size="sm"
            onClick={() => {addAgency(emptyeAgency);}}
          >
            <FaPlus />
          </Button>
        </div>
        <div className="mx-1 d-inline">
          <Button 
            variant="danger"
            className="rounded-circle py-1 px-2 text-white"
            size="sm"
            onClick={() => {deleteAgency(agencies.length-1);}}
            disabled={agencies.length === 1 ? true : false}
          >
            <FaMinus />
          </Button>
        </div>
      </div>
      {agencies.map((agency, index) => {
        return (
          <div key={index} className="my-4">
            <AgencyForm
              index={index}
              agency={agency}
              onChange={updateAgency}
            />
          </div>
        );
      })}
    </>
  );
}

export default AgenciesForm;